/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yourlistinghasbeenupdatedsuccessfully5Inputs */

const en_yourlistinghasbeenupdatedsuccessfully5 = /** @type {(inputs: Yourlistinghasbeenupdatedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your listing has been updated successfully.`)
};

const de_yourlistinghasbeenupdatedsuccessfully5 = /** @type {(inputs: Yourlistinghasbeenupdatedsuccessfully5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Ort wurde aktualisiert.`)
};

/**
* | output |
* | --- |
* | "Your listing has been updated successfully." |
*
* @param {Yourlistinghasbeenupdatedsuccessfully5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const yourlistinghasbeenupdatedsuccessfully5 = /** @type {((inputs?: Yourlistinghasbeenupdatedsuccessfully5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yourlistinghasbeenupdatedsuccessfully5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yourlistinghasbeenupdatedsuccessfully5(inputs)
	return de_yourlistinghasbeenupdatedsuccessfully5(inputs)
});
export { yourlistinghasbeenupdatedsuccessfully5 as "yourListingHasBeenUpdatedSuccessfully" }